import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import AttendanceStatusBadge from './AttendanceStatusBadge';
import {
  formatUKDate,
  formatUKTime,
  minutesToHoursMinutes,
  renderPaidHours,
} from '../../utils/attendanceDateTime';

export default function RecentShiftsTable({ rows, title = 'Recent Shifts' }) {
  return (
    <section className="card-rtb" data-testid="recent-shifts-table">
      <h3 className="font-heading text-2xl uppercase text-white">{title}</h3>

      {rows.length === 0 ? (
        <p className="text-[#A1A1AA] text-sm mt-4">No shifts to display yet.</p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-[#3F3F46]">
                <TableHead>Date</TableHead>
                <TableHead>Venue</TableHead>
                <TableHead>Clock In</TableHead>
                <TableHead>Clock Out</TableHead>
                <TableHead>Break</TableHead>
                <TableHead>Paid Hours</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id || row.time_entry_id} className="border-[#27272A]">
                  <TableCell className="text-white">{formatUKDate(row.shift_date || row.clock_in_at)}</TableCell>
                  <TableCell className="text-[#E4E4E7]">{row.venue_name || '-'}</TableCell>
                  <TableCell className="text-[#E4E4E7]">{formatUKTime(row.clock_in_at)}</TableCell>
                  <TableCell className="text-[#E4E4E7]">{row.clock_out_at ? formatUKTime(row.clock_out_at) : '-'}</TableCell>
                  <TableCell className="text-[#E4E4E7]">{minutesToHoursMinutes(row.break_minutes || 0)}</TableCell>
                  <TableCell className="text-[#E4E4E7]">{renderPaidHours(row.paid_hours || 0)}</TableCell>
                  <TableCell>
                    <AttendanceStatusBadge status={row.status || (row.clock_out_at ? 'closed' : 'open')} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </section>
  );
}
